if (!customElements.get('haina-global-map')) {
  customElements.define('haina-global-map', class extends HTMLElement {
    connectedCallback() {
      this.routes = [...this.querySelectorAll('.hn-global-route')];
      this.dots = [...this.querySelectorAll('.hn-global-traveler')];
      this.lengths = this.routes.map(path => path.getTotalLength());
      this.button = this.querySelector('button'); this.elapsed = 0; this.userPaused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.toggle = () => { this.userPaused = !this.userPaused; this.button.setAttribute('aria-pressed', String(this.userPaused)); const label = this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel; const icon = document.createElement('span'); icon.setAttribute('aria-hidden', 'true'); icon.textContent = this.userPaused ? '▶' : 'Ⅱ'; this.button.replaceChildren(document.createTextNode((label || (this.userPaused ? 'Play animation' : 'Pause animation')) + ' '), icon); this.sync(); };
      this.sync = () => {
        cancelAnimationFrame(this.frame); this.last = null;
        const reduced = this.motion.matches;
        this.button.hidden = reduced;
        if (reduced) { this.routes.forEach(p => p.style.strokeDashoffset = '0'); this.dots.forEach(d => d.style.opacity = '0'); }
        const running = this.visible && !document.hidden && !this.userPaused && !reduced;
        this.toggleAttribute('data-running', running);
        if (running) this.frame = requestAnimationFrame(this.tick);
      };
      this.tick = time => {
        if (this.last !== null) this.elapsed += Math.min(time - this.last, 64);
        this.last = time;
        this.routes.forEach((path, i) => {
          const age = this.elapsed - i * 650;
          path.style.strokeDasharray = '1'; path.style.strokeDashoffset = String(1 - Math.max(0, Math.min(1, age / 1300)));
          const point = path.getPointAtLength((Math.max(0, age - 1300) % 4000) / 4000 * this.lengths[i]);
          this.dots[i].setAttribute('cx', point.x); this.dots[i].setAttribute('cy', point.y);
          this.dots[i].style.opacity = age > 1300 ? '1' : '0';
        });
        this.frame = requestAnimationFrame(this.tick);
      };
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: .15 });
      this.button.addEventListener('click', this.toggle);
      this.motion.addEventListener('change', this.sync);
      document.addEventListener('visibilitychange', this.sync);
      this.observer.observe(this); this.sync();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
      this.motion?.removeEventListener('change', this.sync);
      document.removeEventListener('visibilitychange', this.sync);
    }
  });
}
